import React from 'react';

const BodyTypeStep = ({ data, updateData, onNext }) => {
  const types = [
    { id: 'slim', label: 'Slim', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/XeEs6xcu.webp' },
    { id: 'athletic', label: 'Athletic', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/e7-mhn-J.webp' },
    { id: 'curvy', label: 'Curvy', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/wKvEOieb.webp' },
    { id: 'voluptuous', label: 'Voluptuous', image: 'https://assets.fnlfx.com/01JV2AFRDN86SHKPG3N60E96G6/DeFNwGLG.webp' }
  ];

  const handleSelect = (typeId) => {
    updateData('bodyType', typeId);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        What does your girlfriend's body look like?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Select the most exciting option now
      </p>

      <div className="grid grid-cols-2 gap-4">
        {types.map((type) => (
          <button
            key={type.id}
            onClick={() => handleSelect(type.id)}
            className={`group relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 ${
              data.bodyType === type.id ? 'ring-4 ring-[#F1B428] shadow-lg shadow-[#F1B428]/30 scale-105' : 'hover:ring-2 hover:ring-[#F1B428]/50'
            }`}
          >
            <div className="aspect-[3/4] relative bg-[#1A1A1A]">
              <img
                src={type.image}
                alt={type.label}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <span className={`text-lg font-semibold ${
                data.bodyType === type.id ? 'text-[#F1B428]' : 'text-white'
              }`}>{type.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BodyTypeStep;
